export default "__VITE_ASSET__326f102d__"